module.exports = __webpack_public_path__ + "img/7be6436.jpg";